"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var BaseAdapter = require("../BaseAdapter/BaseAdapter");
var _require = require("../../constants/loggingLevels"),
  DEBUG = _require.DEBUG,
  INFO = _require.INFO,
  WARNING = _require.WARNING,
  ERROR = _require.ERROR,
  JSERROR = _require.JSERROR;
var MessagePresenter = require("../../presenters/MessagePresenter");
var logFunction = (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])({}, ERROR, function () {
  var _console;
  return (_console = console).error.apply(_console, arguments);
}), JSERROR, function () {
  var _console2;
  return (_console2 = console).error.apply(_console2, arguments);
}), WARNING, function () {
  var _console3;
  return (_console3 = console).warn.apply(_console3, arguments);
}), INFO, function () {
  var _console4;
  return (_console4 = console).info.apply(_console4, arguments);
}), DEBUG, function () {
  var _console5;
  return (_console5 = console).debug.apply(_console5, arguments);
}), "default", function _default() {
  var _console6;
  return (_console6 = console).log.apply(_console6, arguments);
});
var ConsoleAdapter = /*#__PURE__*/function (_BaseAdapter) {
  /**
   * @param {Object} config - Config object that has .get methods
   * @param {Array<String>} undesiredAttributes - Name of the attributes we don't care about
   */
  function ConsoleAdapter(config, undesiredAttributes) {
    var _this;
    (0, _classCallCheck2["default"])(this, ConsoleAdapter);
    _this = _callSuper(this, ConsoleAdapter, [config]);
    (0, _defineProperty2["default"])(_this, "key", "console");
    (0, _defineProperty2["default"])(_this, "undesiredAttributes", null);
    _this.name = "Logging Service - Console Adapter";
    _this.undesiredAttributes = new Set(undesiredAttributes);
    return _this;
  }
  (0, _inherits2["default"])(ConsoleAdapter, _BaseAdapter);
  return (0, _createClass2["default"])(ConsoleAdapter, [{
    key: "decoratePayloadWithPrefix",
    value: function decoratePayloadWithPrefix() {
      var _this2 = this;
      return Object.entries(this.attributes).filter(function (_ref) {
        var _this2$undesiredAttri, _this2$undesiredAttri2;
        var _ref2 = (0, _slicedToArray2["default"])(_ref, 1),
          key = _ref2[0];
        return !((_this2$undesiredAttri = _this2.undesiredAttributes) !== null && _this2$undesiredAttri !== void 0 && (_this2$undesiredAttri2 = _this2$undesiredAttri.has) !== null && _this2$undesiredAttri2 !== void 0 && _this2$undesiredAttri2.call(_this2$undesiredAttri, key));
      });
    }
  }, {
    key: "processMessage",
    value: function processMessage(level) {
      var _this$undesiredAttrib, _this$undesiredAttrib2;
      //TODO: pre-process the attributes when they're added/deleted instead of when processing each message
      var attributes = this.decoratePayloadWithPrefix();
      var logLevel = (_this$undesiredAttrib = this.undesiredAttributes) !== null && _this$undesiredAttrib !== void 0 && (_this$undesiredAttrib2 = _this$undesiredAttrib.has) !== null && _this$undesiredAttrib2 !== void 0 && _this$undesiredAttrib2.call(_this$undesiredAttrib, "level") ? null : level;
      for (var _len = arguments.length, payload = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        payload[_key - 1] = arguments[_key];
      }
      var contents = [MessagePresenter.buildMessage(logLevel, {
        attributes: attributes
      })].concat(payload);
      var log = logFunction[level] || logFunction["default"];
      log.apply(void 0, (0, _toConsumableArray2["default"])(contents));
    }
  }]);
}(BaseAdapter);
module.exports = ConsoleAdapter;